import React from 'react';
const clients = ['NatuCafé', 'Emilius Pizza', 'NOIZA', 'JAZUGA', 'DMT'];
export function TrustStrip() {
  return <section className="border-y border-white/10 bg-[#0c0c1c] py-6" data-id="element-1657">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-1658">
        <p className="text-sm font-medium text-[#d9d9e4]" data-id="element-1659">
          Negocios y proyectos que ya cuentan con soluciones digitales creadas
          por A-Z.
        </p>
        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-7 gap-y-2.5 text-sm font-semibold tracking-wide text-[#a9a9ba]" data-id="element-1660">
          {clients.map(client => <span key={client} data-id="element-1661">{client}</span>)}
        </div>
        <p className="mt-4 text-xs text-[#79798c]" data-id="element-1662">
          Proyectos para comercio, servicios profesionales, gastronomía y
          productos digitales.
        </p>
      </div>
    </section>;
}